import { useAuth } from '@/hooks/useAuth'
import { EmptyState } from '@/components/states'
import { Lock } from '@/components/icons'

/** A real state, not a defensive branch. */
export function NoScreensPage() {
  const { user } = useAuth()

  return (
    <EmptyState
      icon={Lock}
      title="Your account has no screens assigned"
      description={
        user
          ? `You are signed in as ${user.name} with the ${user.role.name} role, but it does not include access to any part of the panel yet. Ask a Super Admin to assign the permissions you need.`
          : 'Your role does not include access to any part of the panel yet. Ask a Super Admin to assign the permissions you need.'
      }
    />
  )
}
